import { useState } from "react";
import { updateEnrollmentLetterReceived } from "../actions/studensts";
import PdfViewerModal from "./PdfViewerModal";
import EnrollmentStatusBadge from "./EnrollmentStatusBadge";

// Only these usernames may edit "Enrollment Letter Submit" inline from a
// student detail page (mirrors the report-access check in Main.jsx).
const ALLOWED_USERS = ["admin", "asmaa", "abdelrhman", "alaa", "Yara"];

const LABEL = "Enrollment Letter Submit";

export default function EnrollmentLetterField({ studentId, initialValue, fileName, assignedUser }) {
  const username = JSON.parse(localStorage.getItem("profile"))?.value?.[0]?.username;
  const canEdit = ALLOWED_USERS.includes(username);

  const [value, setValue] = useState(
    initialValue === null || initialValue === undefined ? "" : String(Number(initialValue))
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [showPdfModal, setShowPdfModal] = useState(false);

  const handleSelect = async (newValue) => {
    if (saving || newValue === value) return;
    if (newValue === "1" && !assignedUser) {
      setError("Assign this student to a user before marking as Yes.");
      return;
    }
    setSaving(true);
    setError("");
    const res = await updateEnrollmentLetterReceived(studentId, newValue);
    setSaving(false);
    if (res && res.status === 200) {
      setValue(newValue);
    } else {
      setError(res?.data?.ERROR || "Failed to save.");
    }
  };

  return (
    <div className="flex items-center flex-wrap gap-2">
      <label className="font-light">{LABEL}:&nbsp;</label>

      {canEdit ? (
        <>
          <div className="inline-flex rounded-full border border-gray-300 overflow-hidden text-xs font-semibold shrink-0">
            <button
              type="button"
              disabled={saving || !assignedUser}
              title={!assignedUser ? "Assign this student to a user first" : undefined}
              onClick={() => handleSelect("1")}
              className={`px-3 py-1 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                value === "1"
                  ? "bg-green-600 text-white"
                  : "bg-white text-gray-500 hover:bg-gray-100"
              }`}
            >
              Yes
            </button>
            <button
              type="button"
              disabled={saving}
              onClick={() => handleSelect("0")}
              className={`px-3 py-1 border-l border-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                value === "0"
                  ? "bg-red-600 text-white"
                  : "bg-white text-gray-500 hover:bg-gray-100"
              }`}
            >
              No
            </button>
          </div>
          {saving && <span className="text-xs text-gray-400">Saving...</span>}
        </>
      ) : (
        <EnrollmentStatusBadge value={value} />
      )}

      {fileName && (
        <button
          type="button"
          onClick={() => setShowPdfModal(true)}
          className="text-xs text-blue-600 hover:underline"
        >
          View PDF
        </button>
      )}

      <span className="text-xs text-gray-500">
        Assigned To: {assignedUser || "—"}
      </span>

      {error && <span className="text-xs text-red-500 w-full">{error}</span>}

      {showPdfModal && fileName && (
        <PdfViewerModal fileName={fileName} onClose={() => setShowPdfModal(false)} />
      )}
    </div>
  );
}
